// Relative .ts import so scripts/check-locale.ts can load this file in plain Node
import { NOT_FOUND_PATH } from '../../shared/site.ts';

/**
 * MemberSheep's URLs: /membersheep[/zh-tw][/privacy|/terms|/support]. English is unprefixed.
 * Its own two locales, separate from Travo's five (src/travo/i18n/locale.ts).
 */
export type MsLocale = 'en' | 'zh-TW';

export const MS_LOCALES: readonly MsLocale[] = ['en', 'zh-TW'];

export const MS_BASE = '/membersheep';

const MS_PREFIX: Record<MsLocale, string> = { en: '', 'zh-TW': '/zh-tw' };

export const MS_PAGES = {
  home: '/',
  privacy: '/privacy',
  terms: '/terms',
  support: '/support'
} as const;

export type MsPage = (typeof MS_PAGES)[keyof typeof MS_PAGES];

/** Every MemberSheep page; router and prerender both read this list. */
export const MS_PAGE_PATHS: readonly MsPage[] = Object.values(MS_PAGES);

export const isMemberSheepPath = (pathname: string): boolean =>
  pathname === MS_BASE || pathname.startsWith(`${MS_BASE}/`);

export const msLocaleFromPath = (pathname: string): MsLocale => {
  const zh = MS_BASE + MS_PREFIX['zh-TW'];
  return pathname === zh || pathname.startsWith(`${zh}/`) ? 'zh-TW' : 'en';
};

const localized = (locale: MsLocale, page: string): string => MS_BASE + MS_PREFIX[locale] + (page === '/' ? '' : page);

/** Full URL path of a MemberSheep page, or of its 404, in a locale. */
export const msPath = (locale: MsLocale, page: MsPage | typeof NOT_FOUND_PATH): string => localized(locale, page);

/**
 * The same URL in another locale, for language switches: '/membersheep/privacy' → '/membersheep/zh-tw/privacy'.
 * Takes any path under /membersheep, so an unknown one lands on the other locale's 404.
 */
export const msPathInLocale = (pathname: string, locale: MsLocale): string =>
  localized(locale, pathname.slice((MS_BASE + MS_PREFIX[msLocaleFromPath(pathname)]).length) || '/');
